"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPaymentSourcePD = exports.isValidPaymentSource = void 0;
var paymentConsts_1 = require("./consts/paymentConsts");
var isValidPaymentSource = function (paymentSource) {
    return [paymentConsts_1.PD, paymentConsts_1.PS].includes(paymentSource);
};
exports.isValidPaymentSource = isValidPaymentSource;
var isPaymentSourcePD = function (paymentSource) {
    switch (paymentSource) {
        case paymentConsts_1.PD:
            return true;
        case paymentConsts_1.PS:
            return false;
    }
};
exports.isPaymentSourcePD = isPaymentSourcePD;
